export default "__VITE_ASSET__cc5b421c__"